import { render, staticRenderFns } from "./ModalTierValue.vue?vue&type=template&id=2aabaa84&scoped=true&"
import script from "./ModalTierValue.vue?vue&type=script&lang=js&"
export * from "./ModalTierValue.vue?vue&type=script&lang=js&"
import style0 from "./ModalTierValue.vue?vue&type=style&index=0&id=2aabaa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabaa84",
  null
  
)

export default component.exports